import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteFetchList from './InfiniteFetchList';
import DiscussionCard from './DiscussionCard';
import ReactRailsUJS from "../lib/react-rails";

export default class SearchResultsList extends Component {
  static propTypes = {
    perPage: PropTypes.number.isRequired,
    apiUrl: PropTypes.string.isRequired,
    noResultsMessage: PropTypes.string,
    endResultsMessage: PropTypes.string,
  }

  static defaultProps = {
    noResultsMessage: 'No results found',
    endResultsMessage: 'No more results were found',
  }

  handleLoadedItems () {
    setTimeout(() => {
      ReactRailsUJS.mountComponents();
    }, 200);

  }
  renderItem = (item, key) => (
    <div key={key} dangerouslySetInnerHTML={{ __html: item }}>
    </div>
  )

  render() {
    return (
      <InfiniteFetchList
        apiUrl={this.props.apiUrl}
        perPage={this.props.perPage}
        itemRenderer={this.renderItem}
        noResultsMessage={this.props.noResultsMessage}
        reachedEndMessage={this.props.endResultsMessage}
        onLoad={this.handleLoadedItems}
      />
    );
  }
}
